import { environment } from './../environments/environment';

let fastApiUrl = environment.fastApiUrl;
let url = environment.basePath;
let urlV2 = environment.basePathV2;
let authServiceUrl = environment.authServiceBasePath;
let adminServiceUrl = environment.adminServiceBasePath;
let adminServiceUrlV2 = environment.adminServiceBasePathV2;
let planningServiceUrl = environment.planningServieBasePath;
let planningServiceUrlV2 = environment.planningServieBasePathV2;
if (environment.production) {
    // url = `${window.location.protocol}//${window.location.hostname}/api/v1/`
    url = `https://plan.sdbooks.com/api/v1/`
}
export const config = {
    loginFastAPI: `${fastApiUrl}/auth/login`,
    logoutFastAPI: `${fastApiUrl}/auth/logout`,
    refreshLoginFastTokenurl: `${fastApiUrl}/auth/refresh-token`,
    baseUrl: `${adminServiceUrl}file/`,
    login: `${authServiceUrl}user/login`,
    refreshlogintokenurl: `${authServiceUrl}refreshToken`,
    signUp: `${url}user/signup`,
    forgetPassword: `${url}users/forgot-password?email=:email`,
    resetPassword: `${url}users/reset-password`,
    activateUser: `${url}activate-email`,
    logout: `${authServiceUrl}user/logout`,
    verifyEmail: `${url}user/verify-email`,
    verifyUserEmail: `${url}user/verify-user-email`,
    sampleUrl: `${url}tenant/get-tenant-process/:id?page=:page&limit=:limit`,
    addclinic: `${adminServiceUrl}clinic`,
    getclinicTable: `${adminServiceUrl}clinic?pageNo=:page&limit=:limit`,
    getSkillTable: `${adminServiceUrl}skills?pageNo=:page&limit=:limit`,
    editlinic: `${adminServiceUrl}clinic`,
    getSelectedClinic: `${adminServiceUrl}clinicUser`,
    deleteclinic: `${adminServiceUrl}clinic/`,
    usernotification:`${adminServiceUrl}notification`,
    addEditSkills: `${adminServiceUrl}skills`,
    deleteskills: `${adminServiceUrl}skills`,
    getGroups: `${adminServiceUrl}groups`,
    getPlaceOfServiceURL: `${adminServiceUrl}type/placeOfService`,
    // Therapygroup
    addEdittherapygroup: `${adminServiceUrl}grouptherapy/group`,
    deletetherapygroup: `${adminServiceUrl}grouptherapy/group`,
    getgrouptherapygroups: `${adminServiceUrl}grouptherapy/group/getAll?pageNo=:page&limit=:limit`,
 
    // contracts Api
    addContract: `${adminServiceUrl}contract`,
    getContractTable: `${adminServiceUrl}contract?pageNo=:page&limit=:limit`,
    getContractListTable: `${adminServiceUrl}contract/`,
    deleteContract: `${adminServiceUrl}contract/`,
 
    // spots Api
    getSpotTable: `${adminServiceUrl}spots?pageNo=:page&limit=:limit`,
    addEditSpot: `${adminServiceUrl}spots`,
    deleteSpot: `${adminServiceUrl}spots`,
 
    // planner Api
    getPlannerTable: `${adminServiceUrl}planner?pageNo=:page&limit=:limit`,
    addEditPlanner: `${adminServiceUrl}planner`,
    deletePlanner: `${adminServiceUrl}planner`,
 
    // provider Api
    getProviderTable: `${adminServiceUrl}provider?sortBy=name&pageNo=:page&limit=:limit`,
    addEditProvider: `${adminServiceUrl}provider`,
    getProviderAdditionalData: `${adminServiceUrl}provider/providerDetail`,
    addEditProviderStatus: `${adminServiceUrl}user/status`,
    getfutureSessionsCount: `${adminServiceUrl}provider/futureSessionsCount`,
    getAllSessionsOfProvider: `${adminServiceUrl}provider/getAllSessions`,
    //addEditProviderStatusApi: `${adminServiceUrl}provider/status`,
    deleteProvider: `${adminServiceUrl}provider`,
    deleteProviderTeam: `${adminServiceUrl}patient-team`,
    deleteUnavailability: `${adminServiceUrl}unavailability/deleteUnavailability`,
    deleteUnavailabilityGet: `${adminServiceUrl}unavailability`,
    pendingUnavailabilityGet: `${adminServiceUrl}unavailability/pending`,
    patientPastDataGet: `${adminServiceUrl}patient/pastData/`,
 
    deleteUnavailabilityGetReason: `${adminServiceUrl}type/cancellingReasonType`,
    allSpecialSession: `${adminServiceUrl}unavailability/allSpecialSession`,
    providerUnavailability: `${adminServiceUrl}unavailability/all`,
    providerUnavailabilityApprovel: `${adminServiceUrl}unavailability/unavailabilityApproval`,
    providerSkillsURL: `${adminServiceUrl}provider/providerSkills`,
    patientSkillsURL: `${adminServiceUrl}patient/skill`,
    typeJobTitleURL: `${adminServiceUrl}type/jobTitle`,
 
    // imageUpload Api
    uploadImage: `${adminServiceUrl}file?type=:type`,
 
    // resetPassword Api
    resetPasswordGet: `${authServiceUrl}forget-password?email=:email`,
    resetPasswordPut: `${authServiceUrl}reset-password`,
 
    // patientApi
    addEditPatient: `${adminServiceUrl}patient`,
    cancelPatientSchedule: `${adminServiceUrl}scheduling/cancelPatientSchedule`,
    getPatientTable: `${adminServiceUrl}patient?sortBy=name&pageNo=:page&limit=:limit`,
    clinicWisePatientInfo: `${adminServiceUrl}patient/clinicWisePatientInfo`,
    getPatientNotAssignedTable: `${adminServiceUrl}provider/notAssignedPatients/`,
    clinicWiseProviderInfo: `${adminServiceUrl}provider/clinicWiseProviderInfo`,
    deletePatient: `${adminServiceUrl}patient`,
 
    // unavailabilty
    addEditunavailability: `${adminServiceUrl}unavailability`,
    addEditScheduling: `${adminServiceUrl}scheduling`,
    getSchedulingSessionCount: `${adminServiceUrl}scheduling/count`,
 
    deleteSolverSession: `${planningServiceUrl}solver/publishedSession`,
    addEditSolver: `${planningServiceUrl}solver/create`,
    getProviderSchedule: `${planningServiceUrl}solver/providerSchedules`,
    getProviderUnavailabilitySchedule: `${url}unavailability/allUnavailabilityForClinic`,
    getScheduleholidays: `${adminServiceUrl}holidays`,
    getScheduleUpcomingSessions: `${adminServiceUrl}patient`,
    addEditSolverNew: `${planningServiceUrl}solver`,
    solverTargetSession : `${planningServiceUrl}solver/targetSessions`,
    exportDocsDMS: `${adminServiceUrl}sendSchedule/provider`,
    exportScheduleDOC:`${adminServiceUrl}sendSchedule/exportSchedulingData`,
    replanSolver: `${planningServiceUrl}solver/rePlan`,
    assignedProvder: `${planningServiceUrl}solver/changeAssignedSession`,
    swapSessionURL: `${planningServiceUrl}solver/swapSessions`,
    deleteSolver: `${planningServiceUrl}solver/`,
    deleteProblemset: `${planningServiceUrl}solver/problemSet`,
    getAllSolver: `${planningServiceUrl}solver`,
    getProblemSet: `${planningServiceUrl}solver/getProblemSet`,
    updateProblemSetStatus: `${planningServiceUrl}solver/updateProblemSetStatus`,
    approveSolverProblemSet: `${planningServiceUrl}solver/approveProblemSets`,
    ProblemSet: `${planningServiceUrl}solver/getAllEscalatedSession`,
    problemSetSingleData: `${planningServiceUrl}solver/getProblemSetTypeData`,
    // skillType
    getSkillType: `${adminServiceUrl}type/skill`,
 
    //    Patient team Api
    addEditPatientTeam: `${adminServiceUrl}patient-team`,
    getPatientTeam: `${adminServiceUrl}patient-team/getAll?pageNo=:page&limit=:limit`,
    deletePatientTeam: `${adminServiceUrl}patient-team/provider`,
    providerPatientTeam: `${adminServiceUrl}patient-team/provider`,
    getSetProfile: `${adminServiceUrl}user/userProfileDetails`,
    changePassword: `${authServiceUrl}changePassword`,
    primaryProvider:`${adminServiceUrl}patient-team/assignPrimarySupervisor`,
    previousSupervisor:`${adminServiceUrl}patient-team/assignPrimarySupervisor`,
    supervisorHistory:`${adminServiceUrl}patient-team/allSupervisorHistory`,
 
    // Dashboard counts get api
    getProviderPatientcount:`${adminServiceUrl}dashboard/providerPatientCount`,
    getUpdatedClinicsList: `${adminServiceUrl}clinic/userAssignedClinics`,
    getTodayUnavalityList: `${adminServiceUrl}dashboard/unavailability`,
    getPlannedSessionList: `${adminServiceUrl}dashboard/plannedSession`,
    getEsclatedSessionList: `${adminServiceUrl}dashboard/escalatedShift`,
 
 
    // gendercountdashboard
    getAllgendercount:`${adminServiceUrl}dashboard/genderCount`,
 
    // getPlannedunPlannedShift
    getShiftPlanndUnplanned:`${adminServiceUrl}dashboard/plannedUnplannedShiftCount`,
    getCheckProviderUnailabelity:`${adminServiceUrl}unavailability/checkProviderUnavailability`,
 
    // getLoggedUserTypesInCurrentClinic
    getLoggedUserTypesInCurrentClinic:`${adminServiceUrl}user/userTypes`,
    getUserTypesByID:`${adminServiceUrl}user/userType`,
    loginRole:`${adminServiceUrl}user/loginRole/`,
 
   //holidays
 
   holidays : `${adminServiceUrl}holidays`,
 
    // Version 2 URL
 
    // Patient V2
    patientAuthorizationDataGET : `${adminServiceUrlV2}authorization/patient`,
    patientScheduledInfoDataGET : `${adminServiceUrl}patient/`,
 
    // Setting V2
    sequenceDataGet: `${adminServiceUrlV2}clinicSetting/solverSequence`,
    settingDataGet: `${adminServiceUrlV2}clinicSetting`,
    settingHistoryGet: `${adminServiceUrlV2}clinicSetting/clinicSolverSequence/history`,
    updateSolverSequence: `${adminServiceUrlV2}clinicSetting/solverSequence`,
 
    // Job Config V2
    jobConfigDataGet: `${adminServiceUrl}type/jobTitle`,
    jobConfigureDetailGet: `${adminServiceUrl}jobTitleConfig`,
    addjobConfigureSkills: `${adminServiceUrl}jobTitleConfig`,
 
 
    // trash feature
    getTrashUrl:`${adminServiceUrl}trash/allDeleted`,
    restoreData:`${adminServiceUrl}trash/restore/`,
    delPermanently:`${adminServiceUrl}trash/`,
 
    // Authorisation
    addAuth:`${adminServiceUrlV2}authorization/patient/`,
    editAuth:`${adminServiceUrlV2}authorization/update/patient/`,
    delAuth:`${adminServiceUrlV2}authorization/delete/patient/`,
    getPayer:`${adminServiceUrlV2}authorization/payroll`,
    getFacility:`${adminServiceUrlV2}authorization/facility`,
    getCode:`${adminServiceUrlV2}authorization`,
    getSessionDetail:`${adminServiceUrl}scheduling/session-details`,
    getSchedulingInfo: `${adminServiceUrl}scheduling/info`,
    getBillingCode: `${adminServiceUrl}codes`,
    getAdditionalTimeCode: `${adminServiceUrl}codes/additionalTimeCode`,
    getPrenatalHistory: `${adminServiceUrl}prenatalHistory/patient`,
    updatePrenatalHistory: `${adminServiceUrl}prenatalHistory`,
    getGuardianDetails: `${adminServiceUrl}guardians/patients`,
    updateGuardianDetails: `${adminServiceUrl}guardians`,
    updateGuardianSettings: `${adminServiceUrl}guardians/updateGuardianSettings`,
    addGurdianDetails: `${adminServiceUrl}guardians`,
    getFamilyMedicalHistory: `${adminServiceUrl}familyHistories`,
    getDiagnosisCategory: `${adminServiceUrl}diagnosis/category`,
    getDiagnoisNameById: `${adminServiceUrl}diagnosis`,
    getCurrentMedicalHistory: `${adminServiceUrl}currentMedicalHistory`,
    getAllergiesCategory: `${adminServiceUrl}allergies/category`,
    getAllergiesCategoryById: `${adminServiceUrl}allergies`,
    getMedicationCategory: `${adminServiceUrl}medications/category`,
    getMedicationCategoryById: `${adminServiceUrl}medications`,
    getDietaryCategory: `${adminServiceUrl}dietaryRestrictions/category`,
    getDietaryCategoryById: `${adminServiceUrl}dietaryRestrictions`,
    getPrimaryLanguage: `${adminServiceUrl}primaryLanguage`,
    isPayor: `${adminServiceUrl}guardians/validate/payer`,
    isGuardian: `${adminServiceUrl}guardians/validate/primaryGuardian`,
    getStates: `${adminServiceUrl}states`,
    getCountries: `${adminServiceUrl}countries`,
    getAllergenList: `${adminServiceUrl}allergies`,
    getDiagnosisList: `${adminServiceUrl}diagnosis`,
    getMedicationsList: `${adminServiceUrl}medications`,
    getDietaryList: `${adminServiceUrl}dietaryRestrictions`,
    validateExistingPatient: `${adminServiceUrl}patient/validateExistingPatient`,
    updateAdditionalInfo: `${adminServiceUrl}patient/updateAdditionalInformation`,
    validateSession: `${adminServiceUrl}scheduling/authorization/session/validate`,
    getFeeSchedule: `${adminServiceUrl}feeSchedule`,
    getInsuranceCompanies: `${adminServiceUrl}insuranceCompanies`,
    getInsurancePolicies: `${adminServiceUrl}patients`,
    reassignFeeSchedules: `${adminServiceUrl}patients`,
    getJobTitles: `${adminServiceUrl}jobTitles`,
    getProviderCredentials: `${adminServiceUrl}credentials`,
    getDegreeTypes: `${adminServiceUrl}/degreeTypes`,
    getFutureSessionsCount: `${adminServiceUrl}patient`,
    getTaxonomies: `${adminServiceUrl}taxonomies`,
    getAllTaxonomyCodes: `${adminServiceUrl}taxonomies`
};
